import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { AuthenticationService } from "src/app/core/authentication/authentication.service";
import { UserProfileService } from "../../core/http/user-profile.service";

@Component({
    selector: "app-side-nav",
    templateUrl: "./side-nav.component.html",
    styleUrls: ["./side-nav.component.scss"],
    standalone: false
})
export class SideNavComponent implements OnInit, OnDestroy {
  @Input() showHeaderContent;
  pagePermition: any = [];
  private subscriptions = new Subscription();
  //RoleID with NavPermition
  navPages = {
    1: ["Works Review"],
    2: ["Works Review", "User Management"],
    3: ["User Management"],
    4: [
      "Works Review",
      "User Management",
      "Notifications",
      "Standards Management",
    ],
    5: [],
    6: [],
    7: ["Works Review", "User Management"],
    8: ["Works Review"],
    9: ["Works Review"]
  };
  constructor(private userProfileService: UserProfileService,
    private authenticationService: AuthenticationService) {}

  ngOnInit(): void {
    const msalBroadcast$ =
      this.authenticationService.msalBroadcastComplete$.subscribe(() => {
        this.navigationUserPermit();
      });
    this.subscriptions.add(msalBroadcast$);
    
  }

  navigationUserPermit() {
    let permitedPages = [];
    let currentUserRoles;
    this.userProfileService.getUserRoles().subscribe(roles=>{
      currentUserRoles =roles;
      currentUserRoles.forEach((x) => permitedPages.push(...this.navPages[x]));
      this.pagePermition = [...new Set<any>(permitedPages)];
    });  
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

}
